import { auth } from '../../firebase/config'

/**
 * Wacht tot Firebase weet WIE er ingelogd is, en niet langer.
 *
 * Bij een harde herlaad herstelt Firebase de sessie asynchroon. Een component
 * die op mount meteen een gated Cloud Function aanroept, doet dat dus soms
 * vóórdat er een token is. De functie ziet dan `auth: MISSING` en weigert, en
 * de gebruiker krijgt een foutmelding voor iets dat een seconde later gewoon
 * werkt. Gemeten in de logs van `getThemes`: zes weigeringen binnen een paar
 * milliseconden, gevolgd door één geslaagde aanroep.
 *
 * Lost NIET op dat iemand uitgelogd is: dan komt `null` terug, gaat de aanroep
 * gewoon door en volgt er een echte permission-denied. Dat hoort ook zo — een
 * geweigerde read moet zichtbaar zijn, niet weggemoffeld achter eindeloos
 * wachten.
 *
 * AI-CONTEXT: See docs/pitfalls.md#state-gate-defaults-open-while-loading
 *
 * @returns {Promise<object|null>} de ingelogde gebruiker, of null
 */
export const whenAuthKnown = () => {
    if (auth.currentUser) return Promise.resolve(auth.currentUser)
    return new Promise((resolve) => {
        // onAuthStateChanged vuurt altijd één keer met de herstelde stand --
        // ook als die 'niemand' is. Meteen afmelden: dit is een eenmalige vraag,
        // geen abonnement, en een blijvende listener per aanroep stapelt op.
        //
        // De callback kan SYNCHROON afgaan, nog voordat onAuthStateChanged zijn
        // afmeldfunctie teruggeeft -- Firebase doet dat als de stand al bekend
        // is. Vandaar de vlag: zonder die volgorde valt `unsubscribe` in zijn
        // temporal dead zone en gooit de hele aanroep.
        let unsubscribe = null
        let klaar = false
        const afmelden = () => {
            if (typeof unsubscribe === 'function') unsubscribe()
        }
        unsubscribe = auth.onAuthStateChanged((user) => {
            klaar = true
            afmelden()
            resolve(user || null)
        })
        // Ging hij synchroon af, dan stond de afmeldfunctie er toen nog niet.
        if (klaar) afmelden()
    })
}

export default whenAuthKnown
